
import { Options, Vue } from 'vue-class-component'
import DatePicker from '@/components/core/DatePicker.vue'
import OrdersService, { ChangeStatusParams } from '@/services/OrdersService'

@Options({
  components: { DatePicker },
  props: {
    orderIds: {
      type: Array as () => number[],
      required: true
    }
  },
  emits: ['success', 'error', 'close'],
})
export default class ChangeOrderStatusForm extends Vue {
  orderIds!: number[]
  statusId = ''
  paymentDate: Date = new Date()
  isLoading = false
  errorMessages: string[] = []
  showErrorMode = false
  serverErrorMessage = ''

  get showPaymentDate(): boolean {
    return this.statusId === '3'
  }

  onStatusChange() {
    if (this.statusId !== '3') {
      this.paymentDate = new Date()
    }
  }

  formatDate(date: Date): string {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  async submit() {
    if (!this.statusId) {
      this.errorMessages = ['Выберите статус']
      return
    }
    
    if (this.statusId === '3' && !this.paymentDate) {
      this.errorMessages = ['Укажите дату выплаты для статуса "Выплачено"']
      return
    }

    this.isLoading = true
    this.errorMessages = []
    this.showErrorMode = false
    this.serverErrorMessage = ''

    try {
      const params: ChangeStatusParams = {
        order_ids: this.orderIds,
        status_id: parseInt(this.statusId)
      }

      if (this.statusId === '3' && this.paymentDate) {
        params.payment_date = this.formatDate(this.paymentDate)
      }

      const response = await OrdersService.changeStatus(params)
      this.$emit('success', response.data)
    } catch (error: any) {
      console.error('Ошибка при изменении статуса:', error)
      
      if (error.response?.data?.message) {
        this.serverErrorMessage = error.response.data.message
        this.showErrorMode = true
      } else if (error.response?.data?.errors) {
        const errors = error.response.data.errors
        if (typeof errors === 'object') {
          const errorArray: string[] = []
          Object.values(errors).forEach((errorArrayItem: any) => {
            if (Array.isArray(errorArrayItem)) {
              errorArrayItem.forEach((err: string) => {
                errorArray.push(err)
              })
            }
          })
          if (errorArray.length > 0) {
            this.serverErrorMessage = errorArray.join('. ')
            this.showErrorMode = true
          }
        }
      } else if (error.message) {
        this.serverErrorMessage = error.message
        this.showErrorMode = true
      } else {
        this.serverErrorMessage = 'Произошла неизвестная ошибка при изменении статуса'
        this.showErrorMode = true
      }
      
      this.$emit('error', error)
    } finally {
      this.isLoading = false
    }
  }

  closeModal() {
    this.$emit('close')
  }

  resetForm() {
    this.statusId = ''
    this.paymentDate = new Date()
    this.errorMessages = []
    this.showErrorMode = false
    this.serverErrorMessage = ''
  }
}
